import { useState, useEffect } from 'react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

function PostCard({ post }) {
  return (
    <div style={{
      background: '#fff', borderRadius: 8,
      boxShadow: '0 0 0 1px rgba(0,0,0,0.08), 0 2px 4px rgba(0,0,0,0.05)',
      marginBottom: 32, overflow: 'hidden'
    }} data-testid={"linkedin-post-card-" + post.id}>
      <div style={{ padding: '16px 16px 12px', display: 'flex', alignItems: 'center', gap: 12 }}>
        <div style={{
          width: 48, height: 48, borderRadius: '50%',
          background: 'linear-gradient(135deg, #1B2A7A, #7CC326)',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          color: '#fff', fontWeight: 700, fontSize: 18
        }}>CS</div>
        <div>
          <div style={{ fontWeight: 600, fontSize: 14, color: '#000' }}>Chandra Shekhar</div>
          <div style={{ fontSize: 12, color: '#666' }}>CBO, ChannelLoyalty.ai | B2B Channel Loyalty Platform</div>
          <div style={{ fontSize: 12, color: '#999' }}>Queued — pending LinkedIn reconnection</div>
        </div>
      </div>

      <div style={{ padding: '0 16px 12px', fontSize: 14, lineHeight: 1.5, color: '#333', whiteSpace: 'pre-line' }}>
        {post.text}
      </div>

      {post.has_image && (
        <div style={{ background: '#1B2A7A' }}>
          <img
            src={`${BACKEND_URL}/api/linkedin/post-image/${post.id}`}
            alt={post.angle}
            style={{ width: '100%', display: 'block' }}
          />
        </div>
      )}

      <div style={{
        padding: '12px 16px', background: '#f8f8f8', borderTop: '1px solid #eee',
        fontSize: 13, color: '#1B2A7A', fontWeight: 600
      }}>
        {post.angle}
      </div>
    </div>
  );
}

export default function LinkedInPreview() {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [status, setStatus] = useState(null);

  useEffect(() => {
    let timer;
    async function load() {
      try {
        const [pRes, sRes] = await Promise.all([
          fetch(`${BACKEND_URL}/api/linkedin/queued-posts`),
          fetch(`${BACKEND_URL}/api/linkedin/batch-status`),
        ]);
        const pData = await pRes.json();
        const sData = await sRes.json();
        setPosts(pData.posts || []);
        setStatus(sData);
        if (sData && sData.status === 'running') {
          timer = setTimeout(load, 10000);
        }
      } catch (e) {
        // silent
      } finally {
        setLoading(false);
      }
    }
    load();
    return () => clearTimeout(timer);
  }, []);

  const cards = posts.map(function(p) { return <PostCard key={p.id} post={p} />; });

  return (
    <div style={{
      minHeight: '100vh', background: '#f3f2ef', padding: '40px 20px',
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif'
    }} data-testid="linkedin-preview-page">
      <div style={{ maxWidth: 600, margin: '0 auto' }}>
        <h1 style={{ fontSize: 24, fontWeight: 700, color: '#1B2A7A', marginBottom: 8, textAlign: 'center' }}>
          LinkedIn Post Queue
        </h1>
        <p style={{ fontSize: 14, color: '#666', textAlign: 'center', marginBottom: 12 }}>
          Generated with the official ChannelLoyalty branding — publish after reconnecting LinkedIn
        </p>
        {status && status.status === 'running' && (
          <p style={{ fontSize: 13, color: '#7CC326', textAlign: 'center', marginBottom: 24, fontWeight: 600 }} data-testid="batch-running-indicator">
            Generating {status.done}/{status.total}… current: {status.current}
          </p>
        )}
        {loading && <p style={{ textAlign: 'center', color: '#999' }}>Loading…</p>}
        {!loading && posts.length === 0 && (
          <p style={{ textAlign: 'center', color: '#999' }} data-testid="no-queued-posts">
            No queued posts yet.
          </p>
        )}
        {cards}
      </div>
    </div>
  );
}
